"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Apr 25 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var WindowUpdateDTO_1 = require("../model/WindowUpdateDTO");

var WindowConverter_1 = require("./WindowConverter");

var WindowUpdateDTOConverter_1 = require("./WindowUpdateDTOConverter");

var WindowSimulationConverter_1 = require("./WindowSimulationConverter");

var utils_1 = require("../../core/utils");
/**
 * Default implementation of WindowItemUpdateDTOConverter.
 *
 * @author BPo
 */


var WindowUpdateDTOConverterImpl =
/*#__PURE__*/
function (_WindowUpdateDTOConve) {
  _inherits(WindowUpdateDTOConverterImpl, _WindowUpdateDTOConve);

  /**
   * @param familyConverter converter of {@link Family family}
   */
  function WindowUpdateDTOConverterImpl(windowConverter, windowSimulationConverter) {
    var _this;

    _classCallCheck(this, WindowUpdateDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowUpdateDTOConverterImpl).call(this));
    _this.windowConverter = windowConverter;
    _this.windowSimulationConverter = windowSimulationConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowUpdateDTOConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        document: this.windowConverter.toDocument(source.document, conversions),
        simulation: conversions.asObjectOpt(source, 'simulation', function (object) {
          return utils_1.Utils.isValueMissing(object) ? null : _this2.windowSimulationConverter.toDocument(object, conversions);
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this3 = this;

      return new WindowUpdateDTO_1.WindowUpdateDTO(this.windowConverter.toObject(source.document, conversions), conversions.asObjectOpt(source, 'simulation', function (document) {
        return utils_1.Utils.isValueMissing(document) ? null : _this3.windowSimulationConverter.toObject(document, conversions);
      }));
    }
  }]);

  return WindowUpdateDTOConverterImpl;
}(WindowUpdateDTOConverter_1.WindowUpdateDTOConverter);

WindowUpdateDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowConverter_1.WindowConverter, WindowSimulationConverter_1.WindowSimulationConverter])], WindowUpdateDTOConverterImpl);
exports.WindowUpdateDTOConverterImpl = WindowUpdateDTOConverterImpl;